import { render, staticRenderFns } from "./EvidenceGrid.vue?vue&type=template&id=4dedb3bc&scoped=true&"
import script from "./EvidenceGrid.vue?vue&type=script&lang=js&"
export * from "./EvidenceGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dedb3bc",
  null
  
)

export default component.exports